import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataFlightService } from 'src/app/services';

@Component({
  selector: 'app-net-banking',
  templateUrl: './net-banking.component.html',
  styleUrls: ['./net-banking.component.scss']
})
export class NetBankingComponent implements OnInit {
  @Input() item: any;
  NETBANKING_FORM!: FormGroup;
  NETBANKING_LIST: any[] = [];
  term: string = '';
  selectedNETBANKING: string = '';
  NETBANKING_banking: any = null;
  constructor(private fb: FormBuilder, private DATA_FLIGHT: DataFlightService) { }

  ngOnInit(): void {
    // console.log('Initial item net-banking:', this.item);
    this.NETBANKING_LIST = this.item?.options?.map(i => ({
      ...i, logo: this.DATA_FLIGHT.getBankIcon(i.name)
    })) || [];

    this.NETBANKING_FORM = this.fb.group({ 
      net_banking_value: ['', Validators.required]
    });
  }

  selectWalletBanking(item: any): void {
    this.selectedNETBANKING = item.name;
    this.NETBANKING_FORM.get('net_banking_value')?.setValue(item);
  }

  onRadiowalletChange(event:any): void{
    this.selectedNETBANKING = event.value.name;
    this.NETBANKING_banking = event.value;
  }

  getNETBANKINGPAYMENTFormValue(): any {
    if (this.NETBANKING_FORM.invalid) {
      this.NETBANKING_FORM.markAllAsTouched();
      return null;
    }
    return this.NETBANKING_FORM.value;
  }
}
